import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const STATS = [
    { value: "X+", label: "Diagnoses completed" },
    { value: "5★", label: "Client satisfaction" },
    { value: "8", label: "Calls open each month" },
];

const TESTIMONIALS = [
    {
        quote:
            "She found £412 a month I didn't know I was leaking. In ninety minutes I understood more about my money than in ten years of budgeting apps.",
        name: "Sarah M.",
        meta: "34 · Manchester · The Signal",
        zone: "Amber → Green",
    },
    {
        quote:
            "I wanted Dubai by 30. She showed me the real date at my current pace — then rewrote it. No lectures, just numbers. I book my flight in 14 months.",
        name: "Daniel K.",
        meta: "28 · London · The Dream Plan",
        zone: "Relocation roadmap",
    },
    {
        quote:
            "First time someone told me the truth without dressing it up. Red zone, three concrete moves, no shame. Six weeks later I'm not scared to open my banking app.",
        name: "Priya R.",
        meta: "41 · Birmingham · The Signal",
        zone: "Red → Amber",
    },
    {
        quote:
            "For years my account hit zero on the 28th. After the call I close every month with £280 left. Not luck — the same paycheck, cleaner math.",
        name: "James O.",
        meta: "31 · Leeds · The Signal",
        zone: "Zero → Surplus",
    },
    {
        quote:
            "I thought investing was for other people. She freed up £520 a month from things I didn't even miss. That money now goes into an S&P index fund. Automatic.",
        name: "Emma H.",
        meta: "29 · Bristol · The Dream Plan",
        zone: "Spender → Investor",
    },
    {
        quote:
            "My wife and I had two salaries and no answers. One diagnosis, one shared roadmap, and for the first time we agree on the number. We're 11 months from the deposit.",
        name: "Marcus & Lily T.",
        meta: "36 · Edinburgh · The Dream Plan",
        zone: "House deposit roadmap",
    },
];

export const SocialProof = () => {
    return (
        <section
            id="results"
            data-testid="social-proof-section"
            className="bg-[#11141D] border-y border-white/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
                <p className="overline text-[#C5A059] mb-12">
                    — Results speak in numbers
                </p>

                <div className="grid sm:grid-cols-3 gap-10 md:gap-6">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.label}
                            data-testid={`stat-${i}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.8, delay: i * 0.12, ease }}
                            className="border-t border-white/15 pt-6"
                        >
                            <p className="font-display text-6xl md:text-7xl tracking-tighter text-[#FDFBF7]">
                                {s.value}
                            </p>
                            <p className="font-mono text-xs uppercase tracking-[0.15em] text-white/50 mt-4">
                                {s.label}
                            </p>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    data-testid="testimonials-section"
                    className="mt-20 grid md:grid-cols-3 gap-6"
                >
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            data-testid={`testimonial-${i}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.8, delay: 0.15 + i * 0.12, ease }}
                            className="flex flex-col justify-between p-8 border border-white/10 bg-[#070A13]/60 hover:border-[#C5A059]/40 transition-colors duration-500"
                        >
                            <div>
                                <span className="font-display text-5xl leading-none text-[#C5A059] block mb-4">
                                    &ldquo;
                                </span>
                                <blockquote className="font-display italic text-xl md:text-2xl leading-snug text-[#FDFBF7] tracking-tight">
                                    {t.quote}
                                </blockquote>
                            </div>
                            <figcaption className="mt-8 pt-6 border-t border-white/10">
                                <p className="font-body text-sm text-[#FDFBF7]">
                                    {t.name}
                                </p>
                                <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/40 mt-1">
                                    {t.meta}
                                </p>
                                <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#C5A059] mt-2">
                                    → {t.zone}
                                </p>
                            </figcaption>
                        </motion.figure>
                    ))}
                </motion.div>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="mt-8 font-mono text-[10px] uppercase tracking-[0.15em] text-white/30 text-center"
                >
                    Names changed. Numbers, dates and outcomes are real.
                </motion.p>
            </div>
        </section>
    );
};
